import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const EmptyList = ({ message, c_message }) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('lang'));
  }, [i18n]);

  return (
    <div className="h-alt-hf d-flex flex-column align-items-center justify-content-center text-center">
      <h1 className="page-error color-fusion-500">
        <i className="fal fa-dolly-empty"> </i>
        <small className="fw-500">{c_message}</small>
      </h1>
      <h4>
        {message} <Link to="/"> {t('inicio')}</Link>.
      </h4>
    </div>
  );
};

export default EmptyList;
